import React, { useRef, useState } from 'react';
import SignatureCanvas from 'react-signature-canvas';
import { XMarkIcon } from '@heroicons/react/24/outline';

export default function SignaturePad({ onSave, onCancel }) {
  const sigCanvas = useRef();
  const [isEmpty, setIsEmpty] = useState(true);

  const clear = () => {
    sigCanvas.current.clear();
    setIsEmpty(true);
  };

  const handleEnd = () => {
    setIsEmpty(sigCanvas.current.isEmpty());
  };

  const save = () => {
    if (sigCanvas.current.isEmpty()) {
      alert('Veuillez signer avant de valider');
      return;
    }
    const dataURL = sigCanvas.current.toDataURL();
    onSave(dataURL);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl p-6 max-w-2xl w-full mx-4">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-medium text-gray-900">
            Signature numérique
          </h3>
          <button
            onClick={onCancel}
            className="text-gray-400 hover:text-gray-500"
          >
            <XMarkIcon className="h-6 w-6" />
          </button>
        </div>

        <p className="text-sm text-gray-600 mb-4">
          Signez dans le cadre ci-dessous avec votre souris ou votre doigt (sur écran tactile)
        </p>

        <div className="border-2 border-gray-300 rounded-lg overflow-hidden bg-white">
          <SignatureCanvas
            ref={sigCanvas}
            onEnd={handleEnd}
            canvasProps={{
              width: 700,
              height: 250,
              className: 'signature-canvas',
              style: {
                width: '100%',
                height: '250px'
              }
            }}
            backgroundColor="white"
          />
        </div>

        <div className="flex items-center justify-between mt-4">
          <button
            onClick={clear}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200 transition-colors"
          >
            Effacer
          </button>
          <div className="flex space-x-3">
            <button
              onClick={onCancel}
              className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 transition-colors"
            >
              Annuler
            </button>
            <button
              onClick={save}
              disabled={isEmpty}
              className="px-4 py-2 text-sm font-medium text-white bg-indigo-600 rounded-md hover:bg-indigo-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
            >
              Valider la signature
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
